import axios from 'axios'

export default defineNuxtPlugin((nuxtApp) => {
  const instance = axios.create({
    baseURL: 'https://api.example.com', // <- zmień na swoje API
  })

  nuxtApp.provide('axios', instance)
})